function formatUnitTotal(value) {
  return value % 1 === 0 ? value.toFixed(0) : parseFloat(value.toFixed(2)).toString();
}

function initUnitMetaQuantity(element, options) {
  const {
    qtyInputSelector,
    displaySelector,
    propertySelector,
    minusSelector,
    plusSelector,
    defaultSuffix
  } = options;

  element.unitValue = parseFloat(element.dataset.unitValue);
  element.mode = element.dataset.mode || 'product';
  element.qtyInput = element.querySelector(qtyInputSelector);
  element.display = element.querySelector(displaySelector);
  element.lineProperty = propertySelector ? element.querySelector(propertySelector) : null;

  element.pieces = parseInt(element.qtyInput?.value, 10) || 1;
  if (element.pieces < 1 || Number.isNaN(element.pieces)) {
    element.pieces = 1;
  }

  element.querySelector(minusSelector)?.addEventListener('click', () => element.changePieces(-1));
  element.querySelector(plusSelector)?.addEventListener('click', () => element.changePieces(1));
  element.updateAll(defaultSuffix);
}

if (!customElements.get('unit-length-quantity')) {
  class UnitLengthQuantity extends HTMLElement {
    connectedCallback() {
      initUnitMetaQuantity(this, {
        qtyInputSelector: '[data-ul-qty-input]',
        displaySelector: '[data-ul-display]',
        propertySelector: '[data-ul-length-property]',
        minusSelector: '[data-ul-minus]',
        plusSelector: '[data-ul-plus]',
        defaultSuffix: 'μ.'
      });
    }

    getBillingQty() {
      return this.pieces;
    }

    getTotalLabel(suffix) {
      return `${formatUnitTotal(this.pieces * this.unitValue)} ${suffix}`.trim();
    }

    changePieces(delta) {
      const newPieces = this.pieces + delta;
      if (newPieces < 1) return;

      this.pieces = newPieces;
      this.updateAll(this.dataset.unitSuffix || 'μ.');

      if (this.mode === 'cart' && this.qtyInput) {
        this.qtyInput.dataset.initialValue = String(this.pieces);
        this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updateAll(suffix) {
      const unitSuffix = this.dataset.unitSuffix || suffix || 'μ.';
      const totalLabel = this.getTotalLabel(unitSuffix);
      const billingQty = this.getBillingQty();

      if (this.display) {
        this.display.value = totalLabel;
      }

      if (this.lineProperty) {
        this.lineProperty.value = totalLabel;
      }

      if (this.qtyInput) {
        this.qtyInput.value = String(billingQty);
        this.dataset.billingQty = String(billingQty);
      }
    }
  }

  customElements.define('unit-length-quantity', UnitLengthQuantity);
}

if (!customElements.get('unit-tetr-metra-quantity')) {
  class UnitTetrMetraQuantity extends HTMLElement {
    connectedCallback() {
      initUnitMetaQuantity(this, {
        qtyInputSelector: '[data-utm-qty-input]',
        displaySelector: '[data-utm-display]',
        propertySelector: '[data-utm-area-property]',
        minusSelector: '[data-utm-minus]',
        plusSelector: '[data-utm-plus]',
        defaultSuffix: ''
      });
    }

    getBillingQty() {
      return this.pieces;
    }

    getTotalLabel(suffix) {
      return `${formatUnitTotal(this.pieces * this.unitValue)} ${suffix}`.trim();
    }

    changePieces(delta) {
      const newPieces = this.pieces + delta;
      if (newPieces < 1) return;

      this.pieces = newPieces;
      this.updateAll(this.dataset.unitSuffix || '');

      if (this.mode === 'cart' && this.qtyInput) {
        this.qtyInput.dataset.initialValue = String(this.pieces);
        this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updateAll(suffix) {
      const unitSuffix = this.dataset.unitSuffix || suffix || '';
      const totalLabel = this.getTotalLabel(unitSuffix);
      const billingQty = this.getBillingQty();

      if (this.display) {
        this.display.value = totalLabel;
      }

      if (this.lineProperty) {
        this.lineProperty.value = totalLabel;
      }

      if (this.qtyInput) {
        this.qtyInput.value = String(billingQty);
        this.dataset.billingQty = String(billingQty);
      }
    }
  }

  customElements.define('unit-tetr-metra-quantity', UnitTetrMetraQuantity);
}
